export function convertPlainHttpsLinksToMarkdown(text: string): string {
  // Regex to find HTTPS URLs that are not already in markdown link format
  const httpsRegex = /(?<!\]\()https?:\/\/[^\s<>"{}|\\^`[\]]+/g
  return text?.replace(httpsRegex, url => {
    // Check if this URL is already part of a markdown link
    const beforeUrl = text.substring(0, text.indexOf(url))
    if (beforeUrl.endsWith('](')) {
      return url // Don't convert if it's already a markdown link
    }
    return `[${url}](${url})`
  })
}
